import { LogicalFieldMixin } from './mixins.js';
import LogicFieldListDetail from './list/detail.js';

const LogicalDetail = {
  mixins: [LogicalFieldMixin],

  components: {
    'logic-fields': LogicFieldListDetail
  },

  computed: {
    childrenFields: function() {
      return _.sortBy(this.field.children, 'position');
    }
  },

  data: function() {
    return {
      logicSettings: this.logic || {}
    };
  },

  template: `
    <div class="form-field-input">
      <logic-fields :fields='childrenFields'
                    :logic_settings='logicSettings'
                    :inDetail='true'
                    ref='fields'
                    customClass='detail-children-fields'
                    @updateSetting='updateSettingHandle' />
    </div>
  `,

  methods: {
    updateSettingHandle: function(setting, field) {
      this.$emit('updateSetting', setting, field);
    },

    isValid: function() {
      return this.$refs.fields.isValid();
    },

    displayError: function() {
      return this.$refs.fields.displayError();
    }
  }
};

export default LogicalDetail;
